<div fxLayout="column"
  *ngIf="this.serviceLaneFacade.oemDashboardData$ | async as chryslerDashboardData; else dashboardLoading">
  <div
    *ngIf="chryslerDashboardData.error === null || (chryslerDashboardData?.dashboard?.vip && !chryslerDashboardData?.dashboard?.vip?.error);">
    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;margin-top: 24px;"
      fxLayoutAlign="space-between center">
      <h2>Warning Messages</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(warningMessagesUi)">
        <mat-icon>{{warningMessagesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!warningMessagesUi.collapsed">
      <div class="flex flex-row alerts-container py-0 px-4" id="alertsContainer"
        *ngIf="chryslerDashboardData?.dashboard?.vip?.vehicle?.vehWarningMsg; else noWarningMessages">
        <div *ngIf="isArray(chryslerDashboardData?.dashboard?.vip?.vehicle?.vehWarningMsg); else singleVehicleWarning">
          <div *ngFor="let warning of chryslerDashboardData?.dashboard?.vip?.vehicle?.vehWarningMsg">
            <div fxLayout="row" fxFlex fxLayoutAlign="start center" class="mb-1">
              <span class="primary-bullet">·</span>
              <div fxLayoutAlign="start center">
                <span>{{warning?._text}}</span>
              </div>
            </div>
          </div>
        </div>
        <ng-template #singleVehicleWarning>
          <div>
            <div fxLayout="row" fxFlex fxLayoutAlign="start center" class="mb-1">
              <span class="primary-bullet">·</span>
              <div fxLayoutAlign="start center">
                <span>{{chryslerDashboardData?.dashboard?.vip?.vehicle?.vehWarningMsg?._text}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <ng-template #noWarningMessages>
        <div class="flex flex-row alerts-container py-0 px-4" id="alertsContainer">
          <span>No warning information available.</span>
        </div>
      </ng-template>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Recall Information</h2>
      <button mat-icon-button cass="mr-1" (click)="toggleCollapse(recallInformationUi)">
        <mat-icon>{{recallInformationUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!recallInformationUi.collapsed">
      <div class="flex flex-row alerts-container py-0 px-4" id="alertsContainer">
        <div *ngIf="chryslerDashboardData?.dashboard?.vip?.recallInfoError; else recalls" class="mb-1">
          <span>{{chryslerDashboardData?.dashboard?.vip?.recallInfoError?._text}}</span>
        </div>
        <ng-template #recalls>

          <div *ngIf="isArray(chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall) else singleRecall">
            <div fxLayout="column" class="alert-block"
              *ngFor="let recall of chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall">
              <div class="flex flex=row mb-1" fxLayoutAlign="start center">
                <div fxLayoutAlign="center center" class="danger">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <span class="font-medium ml-2 text-base"> {{recall._attributes.reclNum}} </span>
                <span *ngIf="recall.reclLaunchDt != null; else noCampaignDate" class="campaign-info"> · Recall date is
                  {{recall.reclLaunchDt.date._attributes.month}}/{{recall.reclLaunchDt.date._attributes.day}}/{{recall.reclLaunchDt.date._attributes.year}}
                </span>
                <ng-template #noCampaignDate>
                  <span class="campaign-info"> · Unknown recall date</span>
                </ng-template>
              </div>
              <div fxLayoutAlign="start start" class="pl-8">
                <span class="primary-bullet">·</span>
                <span>{{recall._attributes.reclDesc}} - <span
                    class="font-medium">{{recall._attributes.reclStatus}}</span> </span>
              </div>
            </div>
          </div>

          <ng-template #singleRecall>
            <div fxLayout="column" class="alert-block">
              <div class="flex flex-row mb-1" fxLayoutAlign="start center">
                <div fxLayoutAlign="center center" class="danger">
                  <mat-icon class="text-base pb-1" fxLayoutAlign="center center">warning</mat-icon>
                </div>
                <span class="font-medium ml-2 text-base">
                  {{chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall._attributes.reclNum}} </span>
                <span
                  *ngIf="chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall.reclLaunchDt != null; else noCampaignDate"
                  class="campaign-info"> · Recall date is
                  {{chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall.reclLaunchDt.date._attributes.month}}/{{chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall.reclLaunchDt.date._attributes.day}}/{{chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall.reclLaunchDt.date._attributes.year}}
                </span>
                <ng-template #noCampaignDate>
                  <span class="campaign-info"> · Unknown recall date</span>
                </ng-template>
              </div>
              <div fxLayoutAlign="start start" class="pl-8">
                <span class="primary-bullet">·</span>
                <span>{{chryslerDashboardData?.dashboard?.vip?.recallInfo?.recall._attributes.reclDesc}} </span>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Warranty Warnings</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(warrantyWarningsUi)">
        <mat-icon>{{warrantyWarningsUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!warrantyWarningsUi.collapsed">
      <div class="flex flex-col alerts-container py-0 px-4" id="alertsContainer">
        <div
          *ngIf="isArray(chryslerDashboardData?.dashboard?.vip?.warrantyCoverage?.wcWarningMsg); else singleWarrantyWarning">
          <div *ngFor="let warning of chryslerDashboardData?.dashboard?.vip?.warrantyCoverage?.wcWarningMsg">
            <div fxLayoutAlign="start center" class="flex flex-row mb-1">
              <span class="primary-bullet">·</span>
              <div fxLayoutAlign="start center">
                <span>{{warning?._text}}</span>
              </div>
            </div>
          </div>
        </div>
        <ng-template #singleWarrantyWarning>
          <div fxLayout="row" fxFlex fxLayoutAlign="start center" class="mb-1">
            <span class="primary-bullet">·</span>
            <div fxLayoutAlign="start center">
              <span>{{chryslerDashboardData?.dashboard?.vip?.warrantyCoverage?.wcWarningMsg?._text}}</span>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>

    <div
      style="width:100%;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;"
      fxLayoutAlign="space-between center">
      <h2>Warranty Information</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(warrantyInformationUi)">
        <mat-icon>{{warrantyInformationUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
        </mat-icon>
      </button>
    </div>

    <ng-container *ngIf="!warrantyInformationUi.collapsed">
      <div class="alerts-container" id="alertsContainer" class="flex flex-row py-0 px-4">
        <table mat-table [dataSource]="chryslerDashboardData?.dashboard?.vip?.warrantyCoverage?.warranty"
          class="w-full mat-elevation-z1">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let warranty"> {{warranty._attributes.type}} </td>
          </ng-container>

          <ng-container matColumnDef="original">
            <th mat-header-cell *matHeaderCellDef> Original </th>
            <td mat-cell *matCellDef="let warranty"> {{warranty.original._attributes.months}} Months or
              {{warranty.original._attributes.reading}} {{warranty.original._attributes.readingType}} </td>
          </ng-container>

          <ng-container matColumnDef="deductible">
            <th mat-header-cell *matHeaderCellDef> Deductible </th>
            <td mat-cell *matCellDef="let warranty"> ${{warranty.deductible._attributes.amount}} </td>
          </ng-container>

          <ng-container matColumnDef="expires">
            <th mat-header-cell *matHeaderCellDef> Expires </th>
            <td mat-cell *matCellDef="let warranty">
              {{warranty.expires.date._attributes.month}}/{{warranty.expires.date._attributes.day}}/{{warranty.expires.date._attributes.year}}
            </td>
          </ng-container>

          <ng-container matColumnDef="remaining">
            <th mat-header-cell *matHeaderCellDef> Remaining </th>
            <td mat-cell *matCellDef="let warranty"> {{warranty.remaining._attributes.months == 0 ? 'Expired (Time)' :
              warranty.remaining._attributes.months + 'months'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #dashboardLoading>
  <ng-container fxLayout="column">
    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Warning Messages</h2>
    </div>
    <div class="alerts-container py-0 px-4" id="alertsContainer">
      <div fxLayout="column" class="alert-block">
        <div fxLayout="row" class="mb-1" fxLayoutAlign="start center">
          <!-- <div fxLayoutAlign="center center">
            <div style="height:24px;width:24px;margin:6px 0 6px 8px;border-radius:8px;" class="animated-background"></div>
          </div> -->
          <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
          </div>
          <span class="h-3.5 w-1/3 my-1.5 mr-0 ml-2 rounded animated-background"></span>



        </div>
        <div fxLayoutAlign="start start" class="pl-8">
          <span class="h-3.5 w-1/5 my-1.5 mr-0 ml-2 rounded animated-background"></span>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Recall Information</h2>
    </div>
    <div class="alerts-container py-0 px-4" id="onStarContainer" fxLayout="column">
      <div fxLayout="column" class="alert-block">
        <span class="font-medium text-base mb-2">Status</span>

        <div fxLayout="row wrap">
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-3.5 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
        </div>
      </div>

      <div fxLayout="column" class="alert-block">

        <div class="mb-2">
          <span class="h-4 w-1/3 my-1.5 mr-0 ml-1 rounded animated-background"></span>
          <span class="font-medium text-base mb-2">Tires</span>
        </div>

        <div fxLayout="row wrap">

          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>

            <div class="flex flex-col ml-1 w-full">
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
            </div>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
            </div>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
            </div>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <div class="flex flex-col ml-1 w-full">
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
              <span class="h-4 w-1/2 my-1.5 mr-0 ml-1 rounded animated-background"></span>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="column" class="alert-block">
        <span class="font-medium text-base mb-2">XM Radio Information</span>

        <div fxLayout="row wrap">
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
        </div>
      </div>

      <div fxLayout="column" class="alert-block">
        <span class="font-medium text-base mb-2">Other</span>

        <div fxLayout="row wrap">
          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>

          <div fxLayout="row" fxFlex="50" class="mb-1" fxLayoutAlign="start start">
            <div class="h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl animated-background">
            </div>
            <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Warranty Warnings</h2>
    </div>

    <div class="py-0 px-4" id="claimsHistoryContainer">
      <div class="result-container w-full flex flex-col">
        <div fxLayoutAlign="space-between center" class="result-header-container">
          <div class="flex flex-col w-full">
            <div class="flex flex-row w-full" fxLayoutAlign="start center">
              <span class="h-5 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
            </div>
            <span class="h-4 w-1/3 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div fxLayout="column" class="result-content-container">
          <div fxLayout="column">
            <div class="flex flex-col w-full">
              <div fxLayout="row" fxLayoutAlign="start start" class="flex flex-row pb-5">
                <div class="h-6 w-6 my-1.2 mr-0 ml-2 rounded-xl animated-background"></div>
                <div class="flex flex-col">
                  <div fxLayoutAlign="start start">
                    <span class="h-4 w-4/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
                  </div>
                  <div class="flex flex-col">
                    <div class="flex flex-col bg-grey-800">
                      <div fxLayoutAlign="start center">
                        <div class="h-1 w-1 my-1.5 mr-0 ml-2 rounded-sm animated-background"></div>
                        <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="width:100%;position:sticky;top:66px;background:linear-gradient(0deg, rgba(255,255,255,0.7978260869565217) 0%, rgba(255,255,255,1) 33%);z-index:1;height:56px;">
      <h2>Warranty Information</h2>
    </div>

    <div class="py-0 px-4" id="claimsHistoryContainer">
      <div class="flex flex-col w-full result-container">
        <div fxLayoutAlign="space-between center" class="result-header-container">
          <div class="flex flex-col w-full">
            <div class="flex flex-row w-full" fxLayoutAlign="start center">
              <span class="animated-background h-5 w-2/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
            </div>
            <span class="animated-background h-4 w-1/3 mt-2.5 mr-0 mb-1.5 ml-2 rounded"></span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="flex flex-col result-content-container">
          <div class="flex flex-col">
            <div class="flex flex-col w-full">
              <div class="flex flex-row pb-5" fxLayoutAlign="start start">
                <div class="h-6 w-6 my-1.5 mb-0 ml-2 rounded-xl animated-background"></div>
                <div class="flex flex-col">
                  <div fxLayoutAlign="start start">
                    <span class="h-4 w-4/5 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
                  </div>
                  <div class="flex flex-col">
                    <div class="flex flex-col bg-blue-grey">
                      <div fxLayoutAlign="start center">
                        <div class="h-1 w-1 my-1.5 mr-0 ml-2 rounded-sm animated-background"></div>
                        <span class="h-4 w-1/2 mt-2.5 mr-0 mb-1.5 ml-2 rounded animated-background"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>